import { CustomizedTypography } from '@components/Customized';
import { colorSet, theme } from '@components/Provider';
import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

interface AmountCardProps {
  title: string;
  description: string;
  amount: number;
  colorType?: 'blue' | 'normal';
}

const AmountCard = ({
  amount,
  description,
  title,
  colorType = 'normal'
}: AmountCardProps) => {
  const { amountCardContainer, descriptionFontColor } = useStyles({
    colorType
  });

  return (
    <div className={amountCardContainer}>
      <div className="amount-card-text-area">
        <CustomizedTypography
          variant="body1"
          fontWeight="500"
          gutterBottoms={1}
          color="inherit"
        >
          {title}
        </CustomizedTypography>
        <CustomizedTypography
          className={descriptionFontColor}
          variant="subtitle2"
          color="textSecondary"
        >
          {description}
        </CustomizedTypography>
      </div>
      <CustomizedTypography
        variant="subtitle1"
        fontWeight="500"
        color="inherit"
      >
        {amount.toLocaleString('kr')}원
      </CustomizedTypography>
    </div>
  );
};

export default AmountCard;

const useStyles = makeStyles<Theme, Pick<AmountCardProps, 'colorType'>>({
  amountCardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: 24,
    height: 204,
    borderRadius: 16,
    boxShadow: theme.shadows[1],
    color: ({ colorType }) =>
      colorType === 'blue' ? colorSet.gray000 : colorSet.gray900,
    border: ({ colorType }) =>
      colorType === 'blue' ? 'none' : `1px solid ${colorSet.gray200}`,
    background: ({ colorType }) =>
      colorType === 'blue'
        ? `linear-gradient(238.36deg, #6DA1FF 0%, #477EEC 100%)`
        : 'none'
  },

  descriptionFontColor: {
    color: ({ colorType }) =>
      colorType === 'blue' ? colorSet.primary300 : colorSet.gray700,
    whiteSpace: 'break-spaces'
  }
});
